export const MODELAFTER_START = 'MODELAFTER_START';
export const MODELAFTER_SUCCESS = 'MODELAFTER_SUCCESS';
export const MODELAFTER_FAIL = 'MODELAFTER_FAIL';
export const MODELAFTER_FILTER = 'MODELAFTER_FILTER';
export const CLEAR_MODELAFTER_RESULTS = 'CLEAR_MODELAFTER_RESULTS';
export const CLEAR_MODELAFTER_SEARCHINPUT = 'CLEAR_MODELAFTER_SEARCHINPUT';
export const ADGROUPS_SCREEN = 'ADGROUPS_SCREEN';
export const UPDATE_ESOS_START = 'UPDATE_ESOS_START';
export const UPDATE_ESOS_SUCCESS = 'UPDATE_ESOS_SUCCESS';
export const UPDATE_ESOS_FAIL = 'UPDATE_ESOS_FAIL';
export const ROLESTRING_START = 'ROLESTRING_START';
export const ROLESTRING_SUCCESS = 'ROLESTRING_SUCCESS';
export const ROLESTRING_FAIL = 'ROLESTRING_FAIL';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
